/*!
 * |=======================================|
 * |        React Switch Case 1.0.3        |
 * |=======================================|
 * Switch statement in React components
 * https://github.com/AlexSergey/react-switch-case
 */
!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react")) : "function" == typeof define && define.amd ? define(["react"], t) : "object" == typeof exports ? exports.Switch = t(require("react")) : e.Switch = t(e.React);
}(this, function (e) {
  return function (e) {
    function t(r) {
      if (n[r]) return n[r].exports;
      var o = n[r] = {
        exports: {},
        id: r,
        loaded: !1
      };
      return e[r].call(o.exports, o, o.exports, t), o.loaded = !0, o.exports;
    }

    var n = {};
    return t.m = e, t.c = n, t.p = "", t(0);
  }([function (e, t, n) {
    "use strict";

    function r(e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    }

    function o(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function i(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }

    function u(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Default = t.Case = void 0;

    var c,
        p,
        a,
        f,
        s = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }(),
        l = n(1),
        h = (r(l), function (e) {
      function t() {
        return o(this, t), i(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
      }

      return u(t, e), s(t, [{
        key: "getChildrens",
        value: function value() {
          var e = this,
              t = [],
              n = [];
          return l.Children.forEach(this.props.children, function (r) {
            switch (r.type.componentName) {
              case "case":
                e.props.condition === r.props.value && t.push(r);
                break;

              case "default":
                n.push(r);
            }
          }), t.length > 0 ? t : n;
        }
      }, {
        key: "render",
        value: function value() {
          var e = this.getChildrens();
          return 0 === e.length ? null : e;
        }
      }]), t;
    }(l.Component)),
        d = (p = c = function (e) {
      function t() {
        return o(this, t), i(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
      }

      return u(t, e), s(t, [{
        key: "render",
        value: function value() {
          return this.props.children;
        }
      }]), t;
    }(l.Component), c.componentName = "case", p),
        y = (f = a = function (e) {
      function t() {
        return o(this, t), i(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
      }

      return u(t, e), s(t, [{
        key: "render",
        value: function value() {
          return this.props.children;
        }
      }]), t;
    }(l.Component), a.componentName = "default", f);

    t.default = h, t.Case = d, t.Default = y;
  }, function (t, n) {
    t.exports = e;
  }]);
});